
import { Link } from 'react-router-dom';

export default function PartnersCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-500/20 rounded-full mb-6">
          <i className="ri-customer-service-2-line text-3xl text-red-100"></i>
        </div>
        
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to Work with Our Partners?
        </h2>
        
        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
          Connect with our trusted network of experts to strengthen your practice. We'll help you find the right solutions for your specific needs.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <Link
            to="/contact"
            className="bg-white text-[#e10708] px-10 py-5 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Assessment
          </Link>
          <a
            href="mailto:protectus@healthcareitpartners.com"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Email Us
          </a>
        </div>

        <div className="mt-12 pt-12 border-t border-gray-700">
          <p className="text-gray-400 text-sm">
            Questions about our partners? Contact us at{' '}
            <a href="mailto:protectus@healthcareitpartners.com" className="text-red-300 hover:text-red-200 transition-colors">
              protectus@healthcareitpartners.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
